<div>
  <div class="header">
    <h1>Manage Users</h1>
  </div>

  <div class="users-list">
    <div class="add-new-user-btn">
      <div class="search-input">
        <input
          type="text"
          placeholder="Search"
          [(ngModel)]="searchQuery"
          (keyup)="search()"
          (blur)="search()"
        />
      </div>
      <a [routerLink]="['/users/new']" class="row-header">+Add a New User</a>
    </div>
    <ngx-datatable
      class="bootstrap gray-bg"
      [rows]="users"
      [columnMode]="'force'"
      [headerHeight]="50"
      [footerHeight]="20"
      [loadingIndicator]="showPreloader"
      [rowHeight]="'auto'"
      [count]="180"
      [limit]="10"
    >
      <ngx-datatable-column
        prop="userId"
        name="Id"
        [width]="20"
      ></ngx-datatable-column>

      <ngx-datatable-column
        prop="username"
        name="Username"
        [width]="40"
      ></ngx-datatable-column>
      <ngx-datatable-column
        prop="email"
        name="Email"
        [width]="30"
      ></ngx-datatable-column>
      <ngx-datatable-column
        *ngIf="
          currentUser.isSuperUser || currentUser.managedTenantIds.length > 1
        "
        prop="tenantId"
        name="Tenant"
        [width]="30"
      >
        <ng-template ngx-datatable-cell-template let-value="value">
          <div>
            {{
              tenantsByIdsDictionary &&
                tenantsByIdsDictionary[value] &&
                tenantsByIdsDictionary[value].name
            }}
          </div>
        </ng-template>
      </ngx-datatable-column>
      <!--<ngx-datatable-column prop="canCreateChannels"  name="Can Create Channels" [width]="50"></ngx-datatable-column>-->
      <ngx-datatable-column prop="lastAuth" name="Last Login(UTC)" [width]="70">
        <ng-template ngx-datatable-cell-template let-value="value">
          {{ value | date: "dd/MM/yyyy HH:mm" }}
        </ng-template>
      </ngx-datatable-column>
      <ngx-datatable-column
        prop="userId"
        [width]="190"
        [sortable]="false"
        [canAutoResize]="false"
        [draggable]="false"
        [resizeable]="false"
        [checkboxable]="false"
      >
        <ng-template
          ngx-datatable-header-template
          let-value="value"
          let-allRowsSelected="allRowsSelected"
          let-selectFn="selectFn"
        >
          <div class="row-header"></div>
        </ng-template>
        <ng-template
          ngx-datatable-cell-template
          let-value="value"
          let-isSelected="isSelected"
          let-onCheckboxChangeFn="onCheckboxChangeFn"
        >
          <div>
            <div class="show-on-row-hover">
              <div class="view-qc-button" (click)="goToEditUser(value)">
                Edit
              </div>
              <div class="view-qc-button" (click)="deleteUser(value)">
                Delete
              </div>
            </div>
          </div>
        </ng-template>
      </ngx-datatable-column>
    </ngx-datatable>
  </div>
</div>
